import { render, staticRenderFns } from "./your-account-helper-components-3-resource-list.vue?vue&type=template&id=a0fbf450&"
import script from "./your-account-helper-components-3-resource-list.vue?vue&type=script&lang=ts&"
export * from "./your-account-helper-components-3-resource-list.vue?vue&type=script&lang=ts&"
import style0 from "./your-account-helper-components-3-resource-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports